<template>
  <input class="btn btn_next" type="submit" :value="translations.move">
</template>

<script>
export default {
  name: 'app-button-move',
  computed: {
    translations() {
      return {
        move: this.$gettext('Přesunout')
      }
    }
  }
}
</script>